import { render, staticRenderFns } from "./PanoramaSharePage.vue?vue&type=template&id=2ac20a1b&scoped=true&"
import script from "./PanoramaSharePage.vue?vue&type=script&lang=js&"
export * from "./PanoramaSharePage.vue?vue&type=script&lang=js&"
import style0 from "./PanoramaSharePage.vue?vue&type=style&index=0&id=2ac20a1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac20a1b",
  null
  
)

export default component.exports